import { render, staticRenderFns } from "./CurrentLocation.vue?vue&type=template&id=5955b060&scoped=true"
import script from "./CurrentLocation.vue?vue&type=script&lang=js"
export * from "./CurrentLocation.vue?vue&type=script&lang=js"
import style0 from "./CurrentLocation.vue?vue&type=style&index=0&id=5955b060&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5955b060",
  null
  
)

export default component.exports